<template>
  <div id="triplice-viral" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="select-situacao info-table-item">
          <vue-select
            :options="filterIdadeOptions"
            label="label"
            placeholder="Idade"
            v-model="filterIdade"
            @input="filtros(exibirCadastrosVermelhos, exibirCadastrosVerdes)"
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="triplice-viral"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'TripliceViralPorEquipeAcs',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      page: 1,
      perPage: 12,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      selectProfissional: '',
      cadastrosOriginais: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      equipeEvent: '',
      disabledRed: false,
      disabledGreen: false,
      disabledSelectEquipe: true,
      loadingSelectEquipe: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      cadastrosOriginaisEquipe: [],
      microArea: '',
      filterIdadeOptions: [...Functions.filterIdadeOptions],
      filterIdade: { label: '1 - 4 anos', value: '1 - 4 anos' },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (this.filterIdade !== null) {
        data = Functions.handleFilterIdade(data, this.filterIdade.value)
      }

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipeEvent = event
        this.loading = true
        this.equipe = event
        this.microArea = ''
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        try {
          this.nomeEquipe = this.equipe.no_equipe
          const response = await Functions.getDadosPorEquipe(
            this.$store.state.cod_ibge,
            this.equipe.nu_ine
          )
          if (response) {
            this.cadastrosOriginaisEquipe = response
            this.cadastros = response
            this.cadastrosOriginais = response
            this.total_de_registros_da_tabela = response.length
            this.filtros(true, false)
            this.setRed = true
            this.loading = false
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.nomeProfissional = ''
        this.profissionais = []
        this.profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.cadastrosOriginaisEquipe = []
        this.selectProfissional = ''
        this.equipe = ''
        this.nomeEquipe = ''
        this.equipeEvent = ''
        return
      }
    },

    async onChangeMicroArea(item) {
      if (item != null) {
        this.microArea = item
        this.cadastrosOriginais = this.cadastrosOriginaisEquipe.filter((el) => {
          return el.micro_area == item.micro_area
        })
        this.cadastros = this.cadastrosOriginaisEquipe.filter((el) => {
          return el.micro_area == item.micro_area
        })
        this.filtros(true, false)
        this.setRed = true
      } else {
        await this.onChangeEquipe(this.equipeEvent)
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.microArea.micro_area
      )
    },
  },
}
</script>

<style>
#triplice-viral .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#triplice-viral .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#triplice-viral .select-situacao .v-select {
  width: 296px;
}
#triplice-viral .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
